import React, { useState, useEffect, useCallback, memo } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = memo(() => {
  const [navOpen, setNavOpen] = useState(false);
  const location = useLocation();

  const toggleNav = useCallback(() => {
    setNavOpen(prev => !prev);
  }, []);

  const closeNav = useCallback(() => {
    setNavOpen(false);
  }, []);

  // Close menu on outside click
  useEffect(() => {
    if (!navOpen) return;
    
    const handleClickOutside = (e) => {
      const nav = document.querySelector('.nav');
      if (nav && !nav.contains(e.target)) {
        closeNav();
      }
    };

    // Close on Escape key
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        closeNav();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [navOpen, closeNav]);

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <header className="site-header" id="header" role="banner">
      <nav className="nav" role="navigation" aria-label="Main navigation">
        <Link className="brand" to="/" onClick={closeNav}>
          <div className="brand-logo-wrapper">
            <img src={`${process.env.PUBLIC_URL || ''}/assets/Logo.png?v=2`} alt="At Every Desk – Compostable paper bottle manufacturer" className="brand-logo" width={48} height={48} onError={(e) => { e.target.onerror = null; e.target.src = '/assets/Logo.png?v=2'; }} />
          </div>
          <span className="brand-text">At Every Desk</span>
        </Link>
        <button className="nav-toggle" aria-label={navOpen ? 'Close menu' : 'Open menu'} aria-expanded={navOpen} aria-controls="main-nav-links" onClick={toggleNav}>☰</button>
        <ul id="main-nav-links" className={`nav-links ${navOpen ? 'open' : ''}`} role="list">
          <li><Link to="/" className={isActive('/') ? 'active' : ''} onClick={closeNav}>Home</Link></li>
          <li><Link to="/about" className={isActive('/about') ? 'active' : ''} onClick={closeNav}>About</Link></li>
          <li><Link to="/product" className={isActive('/product') ? 'active' : ''} onClick={closeNav}>Paper Bottle</Link></li>
          <li><Link to="/other-products" className={isActive('/other-products') ? 'active' : ''} onClick={closeNav}>Other Products</Link></li>
          <li><Link to="/services" className={isActive('/services') ? 'active' : ''} onClick={closeNav}>Services</Link></li>
          <li><Link to="/contact" className={`btn btn--sm ${isActive('/contact') ? 'active' : ''}`} onClick={closeNav}>Get in touch</Link></li>
        </ul>
      </nav>
    </header>
  );
});

Header.displayName = 'Header';

export default Header;

